import { Roles, StudyRoles, User } from '../../../models/Auth'

export const isAcordSpecialist = (user: User) => {
  return user.Roles.includes(Roles.AcoRDSpecialist)
}

export default isAcordSpecialist
